(function () {
  'use strict';

  /* Rail order is this array's order. A category with no products is hidden from
     the rail automatically, so listing one before it has stock is harmless. */
  var CATS = [
    { key: 'bundles', label: 'Bundles', mono: 'BD' },
    { key: 'wheelbase', label: 'Wheel Base', mono: 'WB' },
    { key: 'wheel', label: 'Steering Wheel', mono: 'SW' },
    { key: 'pedals', label: 'Pedals', mono: 'PD' },
    { key: 'shifter', label: 'Shifter', mono: 'SH' },
    { key: 'handbrake', label: 'Handbrake', mono: 'HB' },
    { key: 'chassis', label: 'Cockpit / Chassis', mono: 'CH' },
    { key: 'monitor', label: 'Monitor / Stand', mono: 'MN' },
    { key: 'seat', label: 'Seat', mono: 'ST' },
    { key: 'pc', label: 'PC / Hardware', mono: 'PC' },
    { key: 'mounts', label: 'Mounts / Adapters', mono: 'AD' },
    { key: 'flight', label: 'Flight', mono: 'FL' },
    { key: 'trucking', label: 'Trucking', mono: 'TR' },
    { key: 'farming', label: 'Farming', mono: 'FM' },
    { key: 'accessories', label: 'Accessories', mono: 'AC' }
  ];

  var PRESET_META = [
    { key: 'entry', name: 'Entry DD', tag: 'Best value' },
    { key: 'immersion', name: 'Immersion', tag: 'Most popular' },
    { key: 'pro', name: 'Pro', tag: 'No compromise' },
    { key: 'flight', name: 'Flight Sim', tag: 'Take off' }
  ];

  var BRANDCOLOR = { 'MOZA': '#c0392b', 'GO Motorsports': '#e0ab00', 'MPI': '#2c5fb3' };

  var MAXQTY = 199;

  /* ---- assembly service --------------------------------------------------
     The assembly buttons are real products so they price, tax and fulfil like
     anything else. Tag EVERY assembly product key:assembly -- e.g. "Professional
     Rig Assembly - Single Monitor" and "Professional Rig Assembly - Triple
     Monitor" -- and one button is rendered per product, in catalogue order. They
     are mutually exclusive: picking one swaps out the other, so a rig can never
     leave with two assembly fees on it.

     Also supported: ONE product tagged key:assembly carrying the single/triple
     split as variants. In that case a button is rendered per variant instead.

     Either way the service is kept OUT of the category grid, the rail and the
     component counts -- it is a service, not a part -- but it lands in the total
     and in the cart, and it ignores blocks: rules so a bundle covering a whole
     category can never quietly drop it.

     Tagging: key:assembly is the only required tag. A rig: category tag is
     optional; with one the product is still hidden from that category's grid,
     without one it simply never appears anywhere except these buttons.

     Button labels drop whatever the assembly titles share, so the two products
     above read as "Single Monitor" and "Triple Monitor" under one heading.    */
  var ASSEMBLY_KEY = 'assembly';

  /* ---- where to send a build ---------------------------------------------
     Sharing is deliberately plain: the Share panel hands over the build link
     and the address to send it to. No contact form, no POST, nothing that can
     fail silently or land in the wrong inbox -- the shopper mails us directly
     and their own address is the reply-to.

     A theme setting named build_email overrides this without editing JS.      */
  var BUILD_EMAIL = 'sim@gomotorsportsshop.com';

  var CAT_KEYS = CATS.map(function (c) { return c.key; });

  function brandColor(b) { return BRANDCOLOR[b] || '#4a4d57'; }

  // Expects DOLLARS (major units) -- matches Liquid "price": <variant>.price / 100.0
  function money(cents) {
    var n = (cents);
    var s = (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function abbrOf(name) {
    var words = String(name).split(/\s+/).filter(function (w) { return /[A-Za-z0-9]/.test(w); });
    return (words.slice(0, 2).map(function (w) { return w[0]; }).join('') || String(name).slice(0, 2)).toUpperCase();
  }

  /* Styles for the assembly row are injected here rather than added to the
     Liquid section, so this feature is a one-file drop-in. Everything else in
     the builder still styles from the section's own CSS. */
  function injectAssemblyStyles() {
    if (document.getElementById('srb-assembly-css')) return;
    var s = document.createElement('style');
    s.id = 'srb-assembly-css';
    s.textContent = [
      '.srb-assembly{display:flex;align-items:center;gap:16px;flex-wrap:wrap;',
      'justify-content:space-between;padding:14px 16px;margin:0 0 12px;',
      'border:1px solid rgba(0,0,0,.14);border-radius:10px;background:rgba(0,0,0,.02);}',
      '.srb-assembly.on{border-color:#e0ab00;background:rgba(224,171,0,.09);}',
      '.srb-assembly-txt{flex:1;min-width:200px;}',
      '.srb-assembly-txt .h{font-weight:700;font-size:14px;line-height:1.3;}',
      '.srb-assembly-txt .s{font-size:12.5px;opacity:.75;margin-top:3px;line-height:1.45;}',
      '.srb-assembly-badge{display:inline-block;margin-left:6px;padding:1px 7px;border-radius:99px;',
      'background:#e0ab00;color:#111;font-size:10.5px;font-weight:700;vertical-align:1px;letter-spacing:.02em;}',
      '.srb-assembly-opts{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}',
      '.srb-assembly-btn{flex:0 0 auto;cursor:pointer;font:inherit;font-size:13px;font-weight:700;',
      'text-align:center;line-height:1.3;padding:9px 14px;border-radius:8px;',
      'border:1px solid rgba(0,0,0,.28);background:#fff;color:#111;',
      'transition:background .15s,color .15s,border-color .15s;}',
      '.srb-assembly-btn .p{display:block;font-size:11.5px;font-weight:600;opacity:.7;margin-top:2px;}',
      '.srb-assembly-btn:hover{border-color:#111;}',
      '.srb-assembly-btn.on{background:#e0ab00;border-color:#e0ab00;color:#111;}',
      '.srb-assembly-btn.on .p{opacity:.85;}',
      '.srb-assembly-btn[disabled]{opacity:.45;cursor:not-allowed;}',
      '.srb-assembly-btn:focus-visible{outline:2px solid #e0ab00;outline-offset:2px;}',
      '.srb-assembly-clear{cursor:pointer;font:inherit;font-size:12px;font-weight:600;',
      'padding:6px 4px;border:0;background:none;color:inherit;opacity:.7;text-decoration:underline;}',
      '.srb-assembly-clear:hover{opacity:1;}',
      '@media (max-width:520px){.srb-assembly-opts{width:100%;}.srb-assembly-btn{flex:1 1 140px;}}',
      /* share panel note */
      '.srb-sharenote{margin-top:10px;padding:12px 14px;border:1px solid rgba(0,0,0,.14);',
      'border-radius:10px;font-size:13px;line-height:1.5;}',
      '.srb-sharenote .h{font-weight:700;}',
      '.srb-sharenote .s{opacity:.78;margin-top:2px;}',
      '.srb-sharenote-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:9px;}',
      '.srb-sharemail{font-weight:700;font-size:14px;color:inherit;text-decoration:none;',
      'border-bottom:2px solid #e0ab00;padding-bottom:1px;}',
      '.srb-sharemail:hover{border-bottom-color:#111;}',
      '.srb-sharecopy{cursor:pointer;font:inherit;font-size:12px;font-weight:600;padding:5px 10px;',
      'border-radius:6px;border:1px solid rgba(0,0,0,.24);background:#fff;color:#111;}',
      '.srb-sharecopy:hover{border-color:#111;}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---- page loading -------------------------------------------------------
     Liquid paginates at 250 products per page (the platform max) and reports the
     total page count in DATA.pageInfo. Page 1 arrives inline with the document so
     the builder paints immediately; pages 2..N are fetched here in the background
     and merged in. Each page is rendered by the same Liquid section, so metafields,
     price format and tag parsing are identical across every page -- which is why
     this refetches the page rather than hitting the Ajax product JSON endpoint
     (that endpoint does not return metafields, so blurbs and specs would go missing
     for everything past product 250).                                         */

  function pageUrl(n) {
    var params = location.search.replace(/^\?/, '').split('&').filter(function (s) {
      return s && !/^page=/.test(s);
    });
    params.push('page=' + n);
    return location.pathname + '?' + params.join('&');
  }

  // Pulls the [data-srb-data] payload for THIS section out of a fetched document.
  function extractPayload(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrap = sectionId
      ? doc.querySelector('[data-srb][data-section-id="' + sectionId + '"]')
      : null;
    if (!wrap) wrap = doc.querySelector('[data-srb]');
    var el = wrap && wrap.querySelector('[data-srb-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fetchRemainingPages(pageInfo, sectionId, onProgress, onDone) {
    var pages = (pageInfo && +pageInfo.pages) || 1;
    if (!(pages > 1)) return onDone(0);
    var pending = pages - 1;
    var loaded = 0;
    for (var n = 2; n <= pages; n++) {
      (function (pageNo) {
        fetch(pageUrl(pageNo), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            if (!r.ok) throw new Error('page ' + pageNo + ' failed');
            return r.text();
          })
          .then(function (html) {
            var d = extractPayload(html, sectionId);
            if (d && d.products && d.products.length) {
              loaded += d.products.length;
              onProgress(d.products);
            }
          })
          .catch(function (err) {
            if (window.console && console.warn) {
              console.warn('[srb] could not load page ' + pageNo, err);
            }
          })
          .then(function () { if (--pending === 0) onDone(loaded); });
      })(n);
    }
  }

  function initBuilder(rootWrap) {
    var dataEl = rootWrap.querySelector('[data-srb-data]');
    var mount = rootWrap.querySelector('[data-srb-root]');
    if (!dataEl || !mount) return;

    var sectionId = rootWrap.getAttribute('data-section-id') || '';

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = { products: [] }; }

    var pageInfo = DATA.pageInfo || { current: 1, pages: 1 };
    var totalPages = (+pageInfo.pages) || 1;
    var loadingMore = totalPages > 1;

    var PRODUCTS = [];
    var PMAP = {};
    var PRESETS = [];
    var qrAdapter = null;
    var assemblyProducts = [];

    // Merges a batch of products, skipping ids already held. Returns how many were new.
    function ingest(list) {
      var added = 0;
      (list || []).forEach(function (p) {
        if (!p || p.id == null || PMAP[p.id]) return;
        p.abbr = abbrOf(p.title);
        PRODUCTS.push(p);
        PMAP[p.id] = p;
        added++;
      });
      if (added) rebuildDerived();
      return added;
    }

    // PRESETS, qrAdapter and assemblyProducts are computed FROM PRODUCTS, so they
    // must be rebuilt every time a background page lands -- otherwise a preset
    // whose parts live on page 2 would stay permanently empty, and an assembly
    // product on page 2 would never show its button.
    //
    // A preset takes EVERY product tagged preset:<key> in a category, not just the
    // first. Categories that hold several parts of one rig -- flight especially,
    // where stick, throttle, rudder pedals and panel all live in rig:flight --
    // would otherwise load with a single item and look broken. Consequence worth
    // knowing: a stray preset: tag now lands straight in the shopper's total
    // rather than hiding behind whatever sorted first, so audit those tags.
    function rebuildDerived() {
      PRESETS = PRESET_META.map(function (meta) {
        var sel = {};
        CATS.forEach(function (c) {
          var matches = PRODUCTS.filter(function (p) {
            return p.cat === c.key && (p.presets || []).indexOf(meta.key) >= 0;
          });
          if (matches.length) {
            sel[c.key] = matches.map(function (p) { return { id: p.id, qty: 1 }; });
          }
        });
        return { key: meta.key, name: meta.name, tag: meta.tag, sel: sel };
      }).filter(function (pr) { return Object.keys(pr.sel).length; });

      qrAdapter = PRODUCTS.filter(function (p) { return p.isQrAdapter; })[0] || null;

      assemblyProducts = PRODUCTS.filter(function (p) {
        return (p.keys || []).indexOf(ASSEMBLY_KEY) >= 0;
      });
    }

    function isAssembly(p) {
      if (!p) return false;
      for (var i = 0; i < assemblyProducts.length; i++) {
        if (assemblyProducts[i].id === p.id) return true;
      }
      return false;
    }

    // Longest shared opening of the assembly titles, so "Professional Rig
    // Assembly - Single Monitor" / "- Triple Monitor" can label their buttons
    // "Single Monitor" and "Triple Monitor" under one heading.
    function sharedPrefix(titles) {
      if (titles.length < 2) return '';
      var a = titles[0], n = a.length;
      titles.forEach(function (t) {
        var i = 0;
        while (i < n && i < t.length && a.charAt(i) === t.charAt(i)) i++;
        n = i;
      });
      return a.slice(0, n).replace(/[\s\-\u2013\u2014:|/,(]+$/, '');
    }

    function trimPrefix(title, prefix) {
      if (!prefix || title.length <= prefix.length) return title;
      var rest = title.slice(prefix.length).replace(/^[\s\-\u2013\u2014:|/,)]+/, '');
      return rest || title;
    }

    // Surfaces the two silent failure modes: a rig: tag that matches no category
    // key, and a blocks: tag pointing at a category that does not exist.
    function runDiagnostics() {
      if (!window.console) return;
      var orphans = PRODUCTS.filter(function (p) {
        return CAT_KEYS.indexOf(p.cat) < 0 && !isAssembly(p);   // assembly needs no rig: tag
      });
      if (orphans.length && console.warn) {
        console.warn(
          '[srb] ' + orphans.length + ' product(s) have an unrecognized rig: category and will not render. ' +
          'Valid keys: ' + CAT_KEYS.join(', '),
          orphans.map(function (p) { return p.title + '  ->  rig:' + p.cat; })
        );
      }
      var badBlocks = PRODUCTS.filter(function (p) {
        return (p.blocks || []).some(function (b) { return CAT_KEYS.indexOf(b) < 0; });
      });
      if (badBlocks.length && console.warn) {
        console.warn(
          '[srb] blocks: tag targets a category that does not exist (rule will never fire)',
          badBlocks.map(function (p) { return p.title + '  ->  blocks:' + (p.blocks || []).join('|'); })
        );
      }
      var deadAllows = PRODUCTS.filter(function (p) {
        return (p.allows || []).some(function (a) {
          return !PRODUCTS.some(function (q) { return (q.keys || []).indexOf(a) >= 0; });
        });
      });
      if (deadAllows.length && console.warn) {
        console.warn(
          '[srb] allows: token has no matching key: on any product (exemption will never apply)',
          deadAllows.map(function (p) { return p.title + '  ->  allows:' + (p.allows || []).join('|'); })
        );
      }
      // With multi-product presets, a mis-tagged product is money on the invoice.
      // Print what each preset actually resolved to so a stray tag is visible.
      if (console.info) {
        PRESETS.forEach(function (pr) {
          var titles = [];
          Object.keys(pr.sel).forEach(function (c) {
            pr.sel[c].forEach(function (e) {
              if (PMAP[e.id]) titles.push(c + ': ' + PMAP[e.id].title);
            });
          });
          console.info('[srb] preset "' + pr.key + '" -> ' + titles.length + ' product(s)', titles);
        });
      }
      if (console.info) {
        var aOpts = assemblyOptions();
        console.info(aOpts.length
          ? '[srb] assembly options -> ' + aOpts.length + ' button(s)'
          : '[srb] no assembly service found. Tag your assembly products key:' + ASSEMBLY_KEY + '.',
          aOpts.map(function (o) { return o.label + ' \u2014 ' + money(o.price) + (o.available ? '' : ' (unavailable)'); }));
      }
      if (console.info) {
        console.info('[srb] ' + PRODUCTS.length + ' products loaded across ' + totalPages +
          ' page(s). If this equals 50, the paginate wrapper is missing from the Liquid section.');
      }
    }

    ingest(DATA.products);

    /* ---- selection model ----
       state.sel = { <category>: [ { id: <productId>, qty: <1..MAXQTY> }, ... ] }
       Every category accepts multiple distinct products, each with its own qty.
       One line per product; the variant picker still applies per product.
       The assembly service lives in this same map so it flows into the total and
       the cart for free -- it is just filtered out of the parts-facing views.  */

    function selList(cat) { return state.sel[cat] || []; }

    function selEntry(cat, id) {
      var l = selList(cat);
      for (var i = 0; i < l.length; i++) { if (l[i].id === id) return l[i]; }
      return null;
    }

    function isSel(cat, id) { return !!selEntry(cat, id); }

    function hasCat(cat) { return catList(cat).length > 0; }

    // Selections in a category, minus the assembly service.
    function catList(cat) {
      return selList(cat).filter(function (e) { return !isAssembly(PMAP[e.id]); });
    }

    // Flat [{ p: product, qty: n }] across every category, skipping dead ids.
    function selProducts() {
      var out = [];
      Object.keys(state.sel).forEach(function (c) {
        selList(c).forEach(function (e) {
          var p = PMAP[e.id];
          if (p) out.push({ p: p, qty: e.qty });
        });
      });
      return out;
    }

    // Parts only. Counts, warnings and the rail all speak about parts, not services.
    function componentProducts() {
      return selProducts().filter(function (x) { return !isAssembly(x.p); });
    }

    function lineCount() { return componentProducts().length; }
    function unitCount() {
      return componentProducts().reduce(function (s, x) { return s + x.qty; }, 0);
    }
    function catUnits(cat) {
      return catList(cat).reduce(function (s, e) { return s + e.qty; }, 0);
    }

    /* ---- assembly service ---- */

    // One entry per button: { pid, vid, p, label, price, available }.
    // Several products tagged key:assembly -> a button each. A single product
    // carrying the split as variants -> a button per variant.
    function assemblyOptions() {
      if (!assemblyProducts.length) return [];
      var only = assemblyProducts[0];
      if (assemblyProducts.length === 1 && only.variants && only.variants.length > 1) {
        return only.variants.map(function (v) {
          return {
            pid: only.id, vid: v.id, p: only, label: v.title,
            price: v.price, available: only.available !== false && v.available !== false
          };
        });
      }
      var prefix = sharedPrefix(assemblyProducts.map(function (p) { return p.title; }));
      return assemblyProducts.map(function (p) {
        var v = getSelectedVariant(p);
        return {
          pid: p.id, vid: v ? v.id : p.variantId, p: p,
          label: trimPrefix(p.title, prefix),
          price: v ? v.price : p.price,
          available: p.available !== false
        };
      });
    }

    // Heading above the buttons: the shared part of the titles, or the single
    // product's own title.
    function assemblyHeading() {
      if (!assemblyProducts.length) return '';
      if (assemblyProducts.length === 1) return assemblyProducts[0].title;
      return sharedPrefix(assemblyProducts.map(function (p) { return p.title; })) || 'Rig assembly';
    }

    function selectedAssemblyOption() {
      var opts = assemblyOptions();
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (!isSel(o.p.cat, o.pid)) continue;
        var v = getSelectedVariant(o.p);
        if (!v || v.id === o.vid) return o;
      }
      return null;
    }

    function assemblyOn() { return !!selectedAssemblyOption(); }

    // Clears every assembly line, wherever it sits.
    function dropAssembly() {
      Object.keys(state.sel).forEach(function (c) {
        var kept = state.sel[c].filter(function (e) { return !isAssembly(PMAP[e.id]); });
        if (kept.length) state.sel[c] = kept; else delete state.sel[c];
      });
    }

    // A share link written before this split -- or hand-edited -- could name two
    // assembly products at once. First one wins, qty pinned to 1.
    function enforceSingleAssembly() {
      var taken = false;
      Object.keys(state.sel).forEach(function (c) {
        var kept = state.sel[c].filter(function (e) {
          if (!isAssembly(PMAP[e.id])) return true;
          if (taken) return false;
          taken = true; e.qty = 1; return true;
        });
        if (kept.length) state.sel[c] = kept; else delete state.sel[c];
      });
    }

    // key is "<productId>:<variantId>". Clicking the active option turns it off;
    // clicking the other one swaps.
    function chooseAssembly(key) {
      var bits = String(key).split(':');
      var pid = +bits[0], vid = +bits[1];
      var opt = assemblyOptions().filter(function (o) {
        return o.pid === pid && o.vid === vid;
      })[0];
      if (!opt || !opt.available) return;
      var cur = selectedAssemblyOption();
      var same = cur && cur.pid === opt.pid && cur.vid === opt.vid;
      dropAssembly();
      if (same) { render(); return toast('Assembly removed'); }
      if (vid) state.variantSel[pid] = vid;
      var c = opt.p.cat;
      (state.sel[c] = state.sel[c] || []).push({ id: pid, qty: 1 });
      purgeAndNotify(c);
      render();
      toast(opt.label + ' assembly added \u2014 we\u2019ll build and test the rig before it ships');
    }

    function clearAssembly() {
      if (!assemblyOn()) return;
      dropAssembly(); render(); toast('Assembly removed');
    }

    // Accepts both the current shape and the old { cat: id } shape, so share
    // links and presets saved before multi-select still load.
    function normalizeSel(raw) {
      var out = {};
      Object.keys(raw || {}).forEach(function (c) {
        var v = raw[c], list = [];
        function push(id, qty) {
          if (!PMAP[id]) return;
          for (var i = 0; i < list.length; i++) { if (list[i].id === +id) return; }
          // One assembly per rig, whatever a stale share link claims.
          if (isAssembly(PMAP[id])) qty = 1;
          list.push({ id: +id, qty: Math.max(1, Math.min(MAXQTY, Math.round(+qty) || 1)) });
        }
        if (Array.isArray(v)) {
          v.forEach(function (e) {
            if (e && typeof e === 'object') push(e.id, e.qty); else push(e, 1);
          });
        } else if (v !== null && typeof v === 'object') {
          push(v.id, v.qty);
        } else {
          push(v, 1);
        }
        if (list.length) out[c] = list;
      });
      return out;
    }

    var state = {
      sel: {},
      variantSel: {},
      activeCat: firstNonEmptyCat(),
      compareList: [],
      compareOpen: false,
      shareOpen: false,
      shareUrl: ''
    };

    function firstNonEmptyCat() {
      for (var i = 0; i < CATS.length; i++) {
        if (PRODUCTS.some(function (p) { return p.cat === CATS[i].key && !isAssembly(p); })) return CATS[i].key;
      }
      return 'wheelbase';
    }

    // Raw decoded #build= payload. Kept around because a shared build can reference
    // products that live on a later page -- normalizeSel drops unknown ids, so it is
    // re-applied after each background page lands rather than only once at boot.
    var pendingHash = null;
    try {
      var m = (location.hash || '').match(/build=([^&]+)/);
      if (m) {
        var decoded = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(m[1])))));
        if (decoded && typeof decoded === 'object') pendingHash = decoded;
      }
    } catch (e) {}

    function applyHash() {
      if (!pendingHash) return;
      var next = normalizeSel(pendingHash);
      // Merge rather than replace, so anything the shopper touched while pages were
      // still loading survives.
      Object.keys(next).forEach(function (c) {
        var existing = state.sel[c] || [];
        next[c].forEach(function (e) {
          var dup = false;
          for (var i = 0; i < existing.length; i++) { if (existing[i].id === e.id) { dup = true; break; } }
          if (!dup) existing.push(e);
        });
        state.sel[c] = existing;
      });
      enforceSingleAssembly();
      purgeBlocked();
    }

    function toast(msg) { if (window.goToast) window.goToast(msg); }

    // Returns the currently selected variant object for a product, falling back
    // to its default variant, falling back to its first variant.
    function getSelectedVariant(p) {
      if (!p || !p.variants || !p.variants.length) return null;
      var pickedId = state.variantSel[p.id];
      if (pickedId) {
        var picked = p.variants.filter(function (v) { return v.id === pickedId; })[0];
        if (picked) return picked;
      }
      var byDefault = p.variants.filter(function (v) { return v.id === p.variantId; })[0];
      return byDefault || p.variants[0];
    }

    function unitPrice(p) {
      var v = getSelectedVariant(p);
      return v ? v.price : p.price;
    }

    function total() {
      return selProducts().reduce(function (s, x) {
        return s + unitPrice(x.p) * x.qty;
      }, 0);
    }

    function compat() {
      var w = [];
      var blocked = activeBlocks();

      // Any number of wheels may be in the build; flag every one that needs a QR.
      var needQr = catList('wheel').map(function (e) { return PMAP[e.id]; })
        .filter(function (p) { return p && p.needsQr; });
      var hasAdapter = catList('mounts').some(function (e) {
        var p = PMAP[e.id]; return p && p.isQrAdapter;
      });
      if (needQr.length && !hasAdapter) {
        var fix = qrAdapter
          ? { cat: 'mounts', id: qrAdapter.id, label: 'Add QR adapter · ' + money(unitPrice(qrAdapter)) }
          : null;
        var who = needQr.length === 1
          ? needQr[0].title + ' needs'
          : needQr.map(function (p) { return p.title; }).join(', ') + ' need';
        w.push({ level: 'error', text: who + ' a MOZA Quick Release Adapter to run on a MOZA base.', fix: fix });
      }
      // A bundle ships with its own base, so it counts as one here. Without this,
      // moving the bundles into rig:bundles makes the warning below misfire on
      // every bundle build.
      var hasBase = hasCat('wheelbase') || hasCat('bundles');
      if (hasCat('wheel') && !hasBase && !blocked.wheelbase) {
        w.push({ level: 'warn', text: 'Add a MOZA wheel base to drive your steering wheel.' });
      }
      if (hasBase && !hasCat('pedals') && !blocked.pedals) {
        w.push({ level: 'warn', text: 'Don\u2019t forget a set of pedals to complete the essentials.' });
      }
      return w;
    }

    /* ---- exclusion rules ---- */

    // Map of category key -> array of selected products that block that category.
    function activeBlocks() {
      var out = {};
      componentProducts().forEach(function (x) {
        (x.p.blocks || []).forEach(function (bcat) {
          if (bcat) (out[bcat] = out[bcat] || []).push(x.p);
        });
      });
      return out;
    }

    // Returns the product doing the blocking, or null if p should stay visible.
    function blockedBy(p, blocks) {
      if (isAssembly(p)) return null;                  // a service is never blocked by a part
      var rules = blocks[p.cat] || [];
      for (var i = 0; i < rules.length; i++) {
        var by = rules[i];
        if (by.id === p.id) continue;                  // never hide the blocker itself
        var exempt = (by.allows || []).some(function (a) {
          return (p.keys || []).indexOf(a) >= 0;
        });
        if (!exempt) return by;
      }
      return null;
    }

    // Drop any selection that the current build has made invalid.
    // `keepCat` is exempt so the slot the shopper just touched always wins.
    function purgeBlocked(keepCat) {
      var blocks = activeBlocks(), dropped = [];
      Object.keys(state.sel).forEach(function (c) {
        if (c === keepCat) return;
        var kept = selList(c).filter(function (e) {
          var p = PMAP[e.id];
          if (!p) return false;
          if (blockedBy(p, blocks)) { dropped.push(p.title); return false; }
          return true;
        });
        if (kept.length) state.sel[c] = kept; else delete state.sel[c];
      });
      return dropped;
    }

    function purgeAndNotify(keepCat) {
      var dropped = purgeBlocked(keepCat);
      if (dropped.length) {
        toast('Removed ' + dropped.join(', ') + ' \u2014 already included in your build');
      }
      return dropped;
    }

    /* ---- actions ---- */
    // Toggles a product in/out of its category. Categories hold any number of lines.
    function choose(cat, id) {
      var list = state.sel[cat] || (state.sel[cat] = []);
      var at = -1;
      for (var i = 0; i < list.length; i++) { if (list[i].id === id) { at = i; break; } }
      if (at >= 0) list.splice(at, 1); else list.push({ id: id, qty: 1 });
      if (!list.length) delete state.sel[cat];
      purgeAndNotify(cat);
      render();
    }
    function removeLine(cat, id) {
      var list = selList(cat);
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) { list.splice(i, 1); break; }
      }
      if (!list.length) delete state.sel[cat];
      render();
    }
    function setQty(cat, id, delta) {
      var e = selEntry(cat, id);
      if (!e || isAssembly(PMAP[id])) return;          // one assembly per rig
      var next = Math.max(1, Math.min(MAXQTY, e.qty + delta));
      if (next === e.qty) return;
      e.qty = next;
      render();
    }
    function clearCat(cat) { delete state.sel[cat]; render(); }
    function clearAll() {
      if (!selProducts().length) return;
      state.sel = {}; state.shareOpen = false; pendingHash = null; render(); toast('Build reset');
    }
    function applyPreset(key) {
      var pr = PRESETS.filter(function (p) { return p.key === key; })[0];
      if (!pr) return;
      var keepAssembly = selectedAssemblyOption();
      pendingHash = null;                     // an explicit preset wins over a stale share link
      state.sel = normalizeSel(pr.sel);
      // A preset swaps the parts, not the service the shopper already asked for.
      if (keepAssembly) {
        var c = keepAssembly.p.cat;
        (state.sel[c] = state.sel[c] || []).push({ id: keepAssembly.pid, qty: 1 });
      }
      purgeBlocked();
      render(); toast('Preset loaded — tweak any slot to make it yours');
    }
    function toggleCompare(id) {
      var i = state.compareList.indexOf(id);
      if (i >= 0) state.compareList.splice(i, 1);
      else { if (state.compareList.length >= 4) return toast('Compare up to 4 products at once'); state.compareList.push(id); }
      render();
    }
    function openCompare() {
      if (state.compareList.length < 2) return toast('Pick at least 2 products to compare');
      state.compareOpen = true; render();
    }
    // The #build= link, without touching the address bar. share() still does
    // that; the email body just needs the string.
    function buildLink() {
      try {
        var enc = encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(state.sel)))));
        return { url: location.origin + location.pathname + '#build=' + enc, hash: '#build=' + enc };
      } catch (e) { return { url: '', hash: '' }; }
    }

    function share() {
      var link = buildLink();
      var url = link.url || 'Unable to generate link';
      if (link.hash && history && history.replaceState) {
        try { history.replaceState(null, '', link.hash); } catch (e) {}
      }
      state.shareOpen = true; state.shareUrl = url; render();
    }
    function copyShare() {
      if (navigator.clipboard) navigator.clipboard.writeText(state.shareUrl).catch(function () {});
      toast('Build link copied to clipboard');
    }

    /* ---- where to send a build ---- */

    function shopEmail() { return (DATA && (DATA.buildEmail || DATA.shopEmail)) || BUILD_EMAIL; }

    // Plain-text parts list. Deliberately readable in an email client rather
    // than JSON -- whoever picks this up is quoting from it, not parsing it.
    function buildSummaryText() {
      var rows = [];
      CATS.forEach(function (c) {
        catList(c.key).forEach(function (e) {
          var p = PMAP[e.id]; if (!p) return;
          var v = getSelectedVariant(p);
          var name = p.title + (v && p.variants && p.variants.length > 1 ? ' (' + v.title + ')' : '');
          rows.push('  ' + e.qty + ' x ' + name + ' - ' + money(unitPrice(p) * e.qty));
        });
      });
      // Anything in a category the rail does not cover still belongs on the list.
      componentProducts().forEach(function (x) {
        if (CAT_KEYS.indexOf(x.p.cat) >= 0) return;
        rows.push('  ' + x.qty + ' x ' + x.p.title + ' - ' + money(unitPrice(x.p) * x.qty));
      });
      var pick = selectedAssemblyOption();
      if (pick) rows.push('  Assembly: ' + pick.label + ' - ' + money(pick.price));
      return rows.join('\n') + '\n\n  Estimated total: ' + money(total());
    }

    // Pre-fills a mail to the shop with the parts list and the build link, so
    // the address in the share panel is one click as well as copyable text.
    function mailtoUrl() {
      var body = 'Hi \u2014 here\u2019s my rig build:\n' + buildSummaryText() +
        '\n\nOpen the build:\n' + buildLink().url + '\n\nMy question:\n';
      return 'mailto:' + shopEmail() +
        '?subject=' + encodeURIComponent('Sim rig build - ' + money(total())) +
        '&body=' + encodeURIComponent(body);
    }

    function copyEmail() {
      if (navigator.clipboard) navigator.clipboard.writeText(shopEmail()).catch(function () {});
      toast('Email address copied \u2014 ' + shopEmail());
    }

    function addToCart(btn) {
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var parts = unitCount();
      var chosen = selectedAssemblyOption();
      var items = selProducts().map(function (x) {
        var v = getSelectedVariant(x.p);
        var line = { id: v ? v.id : x.p.variantId, quantity: isAssembly(x.p) ? 1 : x.qty };
        // Line item property so the order tells the shop floor what to build.
        if (isAssembly(x.p) && chosen) {
          line.properties = {
            'Assembly': chosen.label + ' \u00b7 ' + parts + (parts === 1 ? ' component' : ' components')
          };
        }
        return line;
      }).filter(function (it) { return it && it.id; });
      if (!items.length) return toast('Your rig is empty — add some parts first');
      if (btn) btn.disabled = true;
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          updateCartBadge();
          toast(parts + (parts === 1 ? ' component' : ' components') +
            (chosen ? ' + ' + chosen.label + ' assembly' : '') +
            ' added to cart · ' + money(total()));
        })
        .catch(function () { toast('Could not add the rig to cart — please try again.'); })
        .finally(function () { if (btn) btn.disabled = false; });
    }
    function updateCartBadge() {
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      }).catch(function () {});
    }

    /* ---- render ---- */
    function tileStyle(p) {
      if (p.image) return 'background-image:url(' + esc(p.image) + ');';
      var bc = brandColor(p.brand);
      return 'background:linear-gradient(135deg,' + bc + ',' + bc + 'cc);';
    }

    // Quantity stepper, only rendered on a card that is already in the build.
    function qtyHTML(p, entry, unit) {
      return '' +
        '<div class="srb-qty">' +
          (entry.qty <= 1
            ? '<button class="srb-qty-btn srb-qty-rm" data-remove-line="' + p.id + '" aria-label="Remove ' + esc(p.title) + ' from build" title="Remove from build">\u2715</button>'
            : '<button class="srb-qty-btn" data-qty-down="' + p.id + '" aria-label="Decrease quantity">\u2212</button>') +
          '<span class="srb-qty-n" aria-live="polite">' + entry.qty + '</span>' +
          '<button class="srb-qty-btn" data-qty-up="' + p.id + '"' + (entry.qty >= MAXQTY ? ' disabled' : '') + ' aria-label="Increase quantity">+</button>' +
          '<span class="srb-qty-line">' + money(unit * entry.qty) + '</span>' +
        '</div>';
    }

    function cardHTML(p) {
      var entry = selEntry(p.cat, p.id);
      var chosen = !!entry;
      var cmpOn = state.compareList.indexOf(p.id) >= 0;
      var bc = brandColor(p.brand);
      var variant = getSelectedVariant(p);
      var displayPrice = variant ? variant.price : p.price;
      var hasVariants = p.variants && p.variants.length > 1;
      var variantHTML = hasVariants ? (
        '<select class="srb-variant-select" data-variant-for="' + p.id + '">' +
          p.variants.map(function (v) {
            var isSelV = variant && variant.id === v.id;
            return '<option value="' + v.id + '"' + (isSelV ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + ' \u2014 ' + money(v.price) + (v.available ? '' : ' (sold out)') +
              '</option>';
          }).join('') +
        '</select>'
      ) : '';
      return '' +
        '<div class="srb-card' + (chosen ? ' chosen' : '') + '">' +
          '<div class="srb-card-top">' +
            '<span class="srb-tile" style="' + tileStyle(p) + '">' + (p.image ? '' : esc(p.abbr)) + '</span>' +
            '<div style="flex:1;min-width:0;">' +
              '<div class="brand" style="color:' + bc + ';">' + esc(p.brand) + '</div>' +
              '<div class="nm">' + esc(p.title) + '</div>' +
              '<div class="pr">' + money(displayPrice) + '</div>' +
            '</div>' +
          '</div>' +
          (variantHTML ? '<div class="srb-variant-row">' + variantHTML + '</div>' : '') +
          '<div class="blurb">' + esc(p.blurb) + '</div>' +
          (p.available ? '' : '<div class="oos">Out of stock</div>') +
          '<div class="srb-card-btns">' +
            '<button class="srb-select' + (chosen ? ' on' : '') + '" data-choose="' + p.id + '">' + (chosen ? '\u2713 Added' : 'Add') + '</button>' +
            '<button class="srb-cmp' + (cmpOn ? ' on' : '') + '" data-compare="' + p.id + '" title="Add to compare">' + (cmpOn ? '\u2713 Compare' : 'Compare') + '</button>' +
          '</div>' +
          (chosen ? qtyHTML(p, entry, displayPrice) : '') +
        '</div>';
    }

    // The assembly row. Only shown once there is something to assemble.
    function assemblyHTML() {
      var opts = assemblyOptions();
      if (!opts.length || !lineCount()) return '';
      var chosen = selectedAssemblyOption();
      var on = !!chosen;
      // A lone option is a plain yes/no, so it says what it does rather than
      // making the shopper read a tier name.
      var solo = opts.length === 1;

      var btns = opts.map(function (o) {
        var isOn = chosen && chosen.pid === o.pid && chosen.vid === o.vid;
        var label = !o.available
          ? esc(o.label) + '<span class="p">Unavailable</span>'
          : solo
            ? (isOn ? '\u2713 Assembly added' : 'Have it assembled') +
              '<span class="p">' + (isOn ? 'Tap to remove' : '+' + money(o.price)) + '</span>'
            : (isOn ? '\u2713 ' : '') + esc(o.label) + '<span class="p">+' + money(o.price) + '</span>';
        return '<button class="srb-assembly-btn' + (isOn ? ' on' : '') + '"' +
          ' data-assembly="' + o.pid + ':' + o.vid + '"' +
          (o.available ? '' : ' disabled') +
          ' aria-pressed="' + (isOn ? 'true' : 'false') + '">' + label + '</button>';
      }).join('');

      var blurb = (chosen && chosen.p.blurb) || (opts[0].p.blurb) ||
        'We build, wire and bench-test your rig before it ships, so it arrives ready to drive.';

      return '' +
        '<div class="srb-assembly' + (on ? ' on' : '') + '">' +
          '<div class="srb-assembly-txt">' +
            '<div class="h">' + esc(assemblyHeading()) +
              (on ? '<span class="srb-assembly-badge">' + esc(solo ? 'Added' : chosen.label) + '</span>' : '') + '</div>' +
            '<div class="s">' + esc(blurb) + '</div>' +
          '</div>' +
          '<div class="srb-assembly-opts">' + btns +
            (on && !solo ? '<button class="srb-assembly-clear" data-assembly-clear>Remove</button>' : '') +
          '</div>' +
        '</div>';
    }

    // Send-to-shop panel. Opens under the summary, never a modal -- the shopper
    // should still see the rig they are sending.
    // Share panel: the link, then who to send it to. The address is real text
    // (copyable, readable if the mailto: never opens) and a mailto: link.
    function shareHTML() {
      var addr = shopEmail();
      return '' +
        '<div class="srb-share">' +
          '<input value="' + esc(state.shareUrl) + '" readonly><button data-copy>Copy</button>' +
        '</div>' +
        '<div class="srb-sharenote">' +
          '<div class="h">Questions about this build?</div>' +
          '<div class="s">Send us the link and we\u2019ll check it over \u2014 stock, lead times, ' +
            'and anything we\u2019d change before you order.</div>' +
          '<div class="srb-sharenote-row">' +
            '<a class="srb-sharemail" href="' + esc(mailtoUrl()) + '">' + esc(addr) + '</a>' +
            '<button class="srb-sharecopy" data-copy-email>Copy address</button>' +
          '</div>' +
        '</div>';
    }

    function render() {
      // Assembly with nothing to assemble is a dead line in the cart.
      if (assemblyOn() && !lineCount()) dropAssembly();

      var assemblyPick = selectedAssemblyOption();
      var lines = lineCount();
      var units = unitCount();
      var warnings = compat();
      var hasError = warnings.some(function (w) { return w.level === 'error'; });
      var blocks = activeBlocks();

      // Nothing at all AND nothing still inbound -- the merchant setup is wrong.
      if (!PRODUCTS.length && !loadingMore) {
        mount.innerHTML = '<div class="srb-loading">No products found. Tag products with <code>rig:&lt;category&gt;</code> and select the collection in the theme editor.</div>';
        return;
      }
      if (!PRODUCTS.length) {
        mount.innerHTML = '<div class="srb-loading">Loading rig builder&hellip;</div>';
        return;
      }

      function visible(catKey) {
        return PRODUCTS.filter(function (p) {
          return p.cat === catKey && !isAssembly(p) && !blockedBy(p, blocks);
        });
      }

      var railHTML = CATS.map(function (c) {
        // Categories with no products at all stay hidden; categories emptied by an
        // active bundle stay visible so the shopper can see WHY they are empty.
        if (!PRODUCTS.some(function (p) { return p.cat === c.key && !isAssembly(p); })) return '';
        var list = catList(c.key);
        var first = list.length ? PMAP[list[0].id] : null;
        var active = c.key === state.activeCat;
        var blockers = blocks[c.key] || [];
        var covered = !list.length && blockers.length && !visible(c.key).length;
        var monoStyle = first ? ('background:' + brandColor(first.brand) + ';color:#fff;') : '';
        var catQty = catUnits(c.key);
        var summary;
        if (!list.length) {
          summary = covered ? 'Included with ' + esc(blockers[0].title) : 'Not selected';
        } else if (list.length === 1) {
          summary = esc(first.title) + (list[0].qty > 1 ? ' \u00d7' + list[0].qty : '');
        } else {
          summary = list.length + ' products' + (catQty > list.length ? ' \u00b7 ' + catQty + ' units' : '');
        }
        return '' +
          '<button class="srb-rail-item' + (active ? ' active' : '') + (list.length ? ' filled' : '') + (covered ? ' covered' : '') + '" data-cat="' + c.key + '">' +
            '<span class="srb-mono" style="' + monoStyle + '">' + c.mono + '</span>' +
            '<span class="srb-rail-txt"><span class="lbl">' + esc(c.label) + '</span>' +
            '<span class="sum">' + summary + '</span></span>' +
            (list.length > 1 ? '<span class="srb-rail-n">' + list.length + '</span>'
              : list.length ? '<span class="srb-check">\u2713</span>' : '') +
          '</button>';
      }).join('');

      var activeCat = CATS.filter(function (c) { return c.key === state.activeCat; })[0] || CATS[0];
      var opts = visible(state.activeCat);
      var optionsHTML = opts.map(cardHTML).join('');

      // Explain the missing options rather than silently shrinking the grid.
      // The assembly product is excluded from both sides of this count so it can
      // never be reported as a "hidden option".
      var hiddenCount = PRODUCTS.filter(function (p) {
        return p.cat === state.activeCat && !isAssembly(p);
      }).length - opts.length;
      var blockNote = hiddenCount > 0
        ? '<div class="srb-blocknote">' +
            esc(activeCat.label) + ' ' + (opts.length ? 'options are limited' : 'are included') +
            ' with your ' + esc((blocks[state.activeCat] || [{}])[0].title || 'current selection') + '.' +
            (hiddenCount === 1 ? ' 1 option hidden.' : ' ' + hiddenCount + ' options hidden.') +
          '</div>'
        : '';
      if (!opts.length && !blockNote) {
        blockNote = loadingMore
          ? '<div class="srb-blocknote">Still loading products\u2026</div>'
          : '<div class="srb-blocknote">No products in this category yet.</div>';
      }

      // Honest about the fact that more options are still on the way, so a shopper
      // does not commit to a build while half the catalogue is missing.
      var loadNote = loadingMore
        ? '<div class="srb-loadnote">Loading more products\u2026 ' + PRODUCTS.length + ' so far.</div>'
        : '';

      // A preset may now hold several products in one category, so the card count
      // reads units, not slots.
      var presetsHTML = PRESETS.map(function (pr) {
        var pt = 0, pn = 0;
        Object.keys(pr.sel).forEach(function (k) {
          pr.sel[k].forEach(function (e) {
            if (!PMAP[e.id]) return;
            pt += unitPrice(PMAP[e.id]) * e.qty;
            pn += e.qty;
          });
        });
        return '' +
          '<button class="srb-preset" data-preset="' + pr.key + '">' +
            '<div class="tag">' + esc(pr.tag) + '</div>' +
            '<div class="nm">' + esc(pr.name) + '</div>' +
            '<div class="pr">' + money(pt) + ' \u00b7 ' + pn + (pn === 1 ? ' part' : ' parts') + '</div>' +
          '</button>';
      }).join('');

      var warningsHTML = warnings.map(function (w) {
        return '<div class="srb-warn ' + w.level + '"><span class="txt">' + esc(w.text) + '</span>' +
          (w.fix ? '<button class="srb-warn-fix" data-fix-cat="' + w.fix.cat + '" data-fix-id="' + w.fix.id + '">' + esc(w.fix.label) + '</button>' : '') +
          '</div>';
      }).join('');
      var okHTML = (lines >= 2 && !hasError && !warnings.length)
        ? '<div class="srb-ok">All parts compatible — ready to race.</div>' : '';

      mount.innerHTML = '' +
        '<div class="srb-shell">' +
          '<div class="srb-topbar">' +
            '<div><div class="k">' + esc(DATA.kicker || 'GO Motorsports') + '</div>' +
              '<div class="t">' + esc(DATA.heading || 'Sim Rig Builder') + '</div>' +
              '<div class="s">' + esc(DATA.subheading || '') + '</div></div>' +
            '<div class="srb-total-wrap">' +
              '<div class="srb-total-lbl">Est. total</div>' +
              '<div class="srb-total">' + money(total()) + '</div>' +
              '<div class="srb-total-count">' + units + (units === 1 ? ' component' : ' components') +
                (units > lines ? ' \u00b7 ' + lines + ' products' : '') +
                (assemblyPick ? ' \u00b7 assembled' : '') + '</div>' +
            '</div>' +
          '</div>' +
          loadNote +
          (presetsHTML ? '<div class="srb-presets"><div class="srb-presets-lbl">Start from a preset</div><div class="srb-preset-grid">' + presetsHTML + '</div></div>' : '') +
          '<div class="srb-body">' +
            '<div class="srb-rail">' + railHTML + '</div>' +
            '<div class="srb-options">' +
              '<div class="srb-opt-head"><div class="h">' + esc(activeCat.label) + '</div><div class="n">' + opts.length + ' options</div></div>' +
              blockNote +
              '<div class="srb-opt-grid">' + optionsHTML + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="srb-summary">' +
            warningsHTML + okHTML +
            assemblyHTML() +
            '<div class="srb-summary-row">' +
              '<div class="meta">' + units + (units === 1 ? ' component' : ' components') +
                (assemblyPick ? ' + ' + esc(assemblyPick.label) + ' assembly' : '') +
                ' · <b>' + money(total()) + '</b> ' + (hasError ? '· fix compatibility above' : '') + '</div>' +
              '<div class="srb-actions">' +
                '<button class="srb-btn srb-btn-reset" data-reset>Reset</button>' +
                '<button class="srb-btn srb-btn-ghost" data-share>Share build</button>' +
                '<button class="srb-btn srb-btn-primary" data-add>Add rig to cart</button>' +
              '</div>' +
            '</div>' +
            (state.shareOpen ? shareHTML() : '') +
          '</div>' +
        '</div>' +
        compareBarHTML() +
        (state.compareOpen ? compareModalHTML() : '');

    }

    function compareBarHTML() {
      if (!state.compareList.length) return '';
      return '<div class="srb-cmp-bar"><div style="font-size:12.5px;"><b>Compare</b> · ' + state.compareList.length + ' selected</div>' +
        '<button class="view" data-open-compare>View comparison</button>' +
        '<button class="clr" data-clear-compare>Clear</button></div>';
    }

    function compareModalHTML() {
      var cols = state.compareList.map(function (id) {
        var p = PMAP[id]; if (!p) return '';
        var v = getSelectedVariant(p);
        var specs = [{ k: 'Brand', v: p.brand }, { k: 'Price', v: money(v ? v.price : p.price) }].concat(p.specs || []);
        return '<div class="srb-cmp-col"><div class="top">' +
          '<span class="srb-tile" style="' + tileStyle(p) + '">' + (p.image ? '' : esc(p.abbr)) + '</span>' +
          '<div class="nm">' + esc(p.title) + '</div><div class="pr">' + money(v ? v.price : p.price) + '</div></div>' +
          '<div>' + specs.map(function (s) { return '<div class="srb-cmp-spec"><div class="k">' + esc(s.k) + '</div><div class="v">' + esc(s.v) + '</div></div>'; }).join('') + '</div>' +
          '<button class="rm" data-remove-compare="' + id + '">Remove</button></div>';
      }).join('');
      return '<div class="srb-overlay" data-close-compare><div class="srb-modal" data-stop>' +
        '<div class="srb-modal-head"><div class="h">Product Comparison</div><button class="srb-modal-x" data-close-compare>&times;</button></div>' +
        '<div class="srb-cmp-cols">' + cols + '</div></div></div>';
    }

    /* ---- delegated events ---- */
    mount.addEventListener('click', function (e) {
      var t = e.target;
      var el;
      if (t.closest('[data-copy-email]')) return copyEmail();
      if (t.closest('.srb-sharemail')) return;      // let the mailto: link through
      if (t.closest('[data-assembly-clear]')) return clearAssembly();
      if ((el = t.closest('[data-assembly]'))) return chooseAssembly(el.getAttribute('data-assembly'));
      if ((el = t.closest('[data-cat]'))) { state.activeCat = el.getAttribute('data-cat'); return render(); }
      if ((el = t.closest('[data-remove-line]'))) {
        var rmId = +el.getAttribute('data-remove-line');
        if (!PMAP[rmId]) return;
        return removeLine(PMAP[rmId].cat, rmId);
      }
      if ((el = t.closest('[data-qty-up]'))) {
        var upId = +el.getAttribute('data-qty-up');
        if (!PMAP[upId]) return;
        return setQty(PMAP[upId].cat, upId, 1);
      }
      if ((el = t.closest('[data-qty-down]'))) {
        var dnId = +el.getAttribute('data-qty-down');
        if (!PMAP[dnId]) return;
        return setQty(PMAP[dnId].cat, dnId, -1);
      }
      if ((el = t.closest('[data-choose]'))) {
        var chId = +el.getAttribute('data-choose');
        if (!PMAP[chId]) return;
        return choose(PMAP[chId].cat, chId);
      }
      if ((el = t.closest('[data-compare]'))) return toggleCompare(+el.getAttribute('data-compare'));
      if ((el = t.closest('[data-preset]'))) return applyPreset(el.getAttribute('data-preset'));
      if ((el = t.closest('[data-fix-cat]'))) return choose(el.getAttribute('data-fix-cat'), +el.getAttribute('data-fix-id'));
      if (t.closest('[data-reset]')) return clearAll();
      if (t.closest('[data-share]')) return share();
      if (t.closest('[data-copy]')) return copyShare();
      if (t.closest('[data-add]')) return addToCart(t.closest('[data-add]'));
      if (t.closest('[data-open-compare]')) return openCompare();
      if (t.closest('[data-clear-compare]')) { state.compareList = []; state.compareOpen = false; return render(); }
      // Interactive elements INSIDE the modal must be handled BEFORE the data-stop guard:
      if (t.closest('.srb-modal-x')) { state.compareOpen = false; return render(); }
      if ((el = t.closest('[data-remove-compare]'))) return toggleCompare(+el.getAttribute('data-remove-compare'));
      if (t.closest('[data-stop]')) return;                                   // swallow other clicks inside modal body
      if (t.closest('[data-close-compare]')) { state.compareOpen = false; return render(); } // backdrop
    });

    // Per-product variant picker (separate listener: <select> fires "change", not "click")
    mount.addEventListener('change', function (e) {
      var el = e.target.closest('[data-variant-for]');
      if (!el) return;
      var pid = +el.getAttribute('data-variant-for');
      state.variantSel[pid] = +el.value;
      render();
    });

    /* ---- boot ---- */
    applyHash();
    render();

    if (loadingMore) {
      fetchRemainingPages(
        pageInfo,
        sectionId,
        function onProgress(batch) {
          if (!ingest(batch)) return;
          if (!state.activeCat) state.activeCat = firstNonEmptyCat();
          applyHash();                 // a shared build may reference these new ids
          render();
        },
        function onDone() {
          loadingMore = false;
          pendingHash = null;
          rebuildDerived();
          runDiagnostics();
          render();
        }
      );
    } else {
      runDiagnostics();
    }
  }

  function boot() {
    injectAssemblyStyles();
    Array.prototype.slice.call(document.querySelectorAll('[data-srb]')).forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();